module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (86).e5b4fd3e.jpg";